import { render, staticRenderFns } from "./PagamentoAnexoForm.vue?vue&type=template&id=2ccfa49c"
import script from "./PagamentoAnexoForm.vue?vue&type=script&lang=js"
export * from "./PagamentoAnexoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports